export const OPEN_EDIT_LINKED_CUSTOMER_MODAL = 'OPEN_EDIT_LINKED_CUSTOMER_MODAL';
export const CLOSE_EDIT_LINKED_CUSTOMER_MODAL = 'CLOSE_EDIT_LINKED_CUSTOMER_MODAL';
export const CLOSE_EDIT_LINKED_CUSTOMER_ERROR = 'CLOSE_EDIT_LINKED_CUSTOMER_ERROR';

function openEditLinkedCustomerModal(currentForm) {
  return {
    type: OPEN_EDIT_LINKED_CUSTOMER_MODAL,
    isEditLinkedCustomerModalShown: true,
    currentForm
  };
}

function closeEditLinkedCustomerModal() {
  return {
    type: CLOSE_EDIT_LINKED_CUSTOMER_MODAL,
    isEditLinkedCustomerModalShown: false,
    editLinkedCustomerResponse: null,
    editLinkedCustomerError: null
  };
}

function closeEditLinkedCustomerError() {
  return {
    type: CLOSE_EDIT_LINKED_CUSTOMER_ERROR,
    isEditLinkedCustomerModalShown: true,
  };
}

export function showEditLinkedCustomerModal(currentForm) {
  return (dispatch) => {
    dispatch(openEditLinkedCustomerModal(currentForm));
  };
}

export function hideEditLinkedCustomerModal() {
  return (dispatch) => {
    dispatch(closeEditLinkedCustomerModal());
  };
}

export function hideEditLinkedCustomerError() {
  return (dispatch) => {
    dispatch(closeEditLinkedCustomerError());
  };
}
